<div class="truck-list-container">
  <div class="content">
    <div class="search">
      <div class="chips">
        <kion-filter-chips
          [filterChips]="filterChips$ | async"
          (selected)="updateFilter($event)"
        ></kion-filter-chips>
      </div>
      <div class="search-box">
        <kion-search-box
          [resetValue]="resetValue"
          (searchTriggered)="search($event)"
          (searchBoxResetValue)="searchBoxResetValue()"
          (searchBoxCleared)="searchBoxCleared()"
        ></kion-search-box>
      </div>
    </div>
    <div class="filter-bar">
      <div class="total-results" *ngIf="pagination$ | async as pagination">
        {{ 'deviceList.results' | translate : { devices: pagination.total } }}
      </div>
      <div class="sort" *ngIf="networkPartners$ | async as networkPartners">
        <kion-drop-down
          *ngIf="networkPartners"
          [title]="'filter.by.networkPartner' | translate"
          [options]="networkPartners"
          [showDropDownOnClick]="true"
          [showSelectedOption]="true"
          selectedOptionPosition="behind"
          (selected)="networkPartnerChanged($event)"
        ></kion-drop-down>
      </div>
      <div class="sort" *ngIf="devices$ | async as devices">
        <kion-drop-down
          *ngIf="sorts$ | async"
          [title]="'filter.sort.by' | translate"
          [options]="sorts$ | async"
          [showDropDownOnClick]="true"
          [showSelectedOption]="true"
          selectedOptionPosition="behind"
          (selected)="sortChanged($event)"
        ></kion-drop-down>
      </div>
    </div>
    <div class="header">
      <div class="headline" *ngFor="let headline of tableHeadlines">
        {{ 'deviceList.headline.' + headline | translate }}
      </div>
    </div>
    <div class="body" *ngIf="devices$ | async as devices">
      <ng-container *ngIf="devices.length > 0; else noDevices">
        <kion-truck-list-item
          *ngFor="let device of devices"
          [device]="device"
        ></kion-truck-list-item>
      </ng-container>
      <ng-template #noDevices>
        <div class="no-result">
          {{ 'deviceList.noResult.headline' | translate }}
        </div>
      </ng-template>
    </div>
  </div>
  <div
    class="pagination"
    *ngIf="(devices$ | async) && (devices$ | async).length > 0"
  >
    <kion-pagination
      *ngIf="pagination$ | async as pagination"
      [totalPages]="pagination.totalPages"
      [currentPage]="pagination.page"
      [defaultPerPageSelected]="pagination.perPage"
      (perPageChanged)="perPageChanged($event)"
      (pageChanged)="pageChanged($event)"
    ></kion-pagination>
  </div>
</div>
